import { CSSProperties } from 'react';

import { playSound, Sound } from '~/assets/sounds';
import { StyledContainer, StyledImage, StyledInput } from './Search.styled';

interface ISearchProps {
	placeholder?: string;
	onChange?: React.ChangeEventHandler<HTMLInputElement>;
	style?: CSSProperties;
}

const Search: React.FC<ISearchProps> = ({
	placeholder,
	onChange,
	style,
}: ISearchProps) => {
	return (
		<StyledContainer
			style={style}
			onMouseEnter={() => playSound(Sound.LinkCursor)}
		>
			<StyledInput placeholder={placeholder} onChange={onChange} />
			<StyledImage />
		</StyledContainer>
	);
};

export { Search };
